import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../styles/matchstats.css";
import MatchStatsWideCard from "../components/statPageCards/MatchStatsWideCard";
import MatchStatsDetailsInfo from "../components/InfoModals/MatchStatsDetailsInfo";
import MatchStatsH2HCard from "../components/statPageCards/MatchStatsH2HCard";
import MatchStatsFormCard from "../components/statPageCards/MatchStatsFormCard";
import MatchStatsRefereeCard from "../components/statPageCards/MatchStatsRefereeCard";
import InjuredPlayersCard from "../components/statPageCards/InjuredPlayersCard";
import MatchStatsYellowCard from "../components/statPageCards/MatchStatsYellowCard";
import MatchStatsFirstHalfCard from "../components/statPageCards/MatchStatsFirstHalfCard";
import MatchStatsSecondHalfCard from "../components/statPageCards/MatchStatsSecondHalfCard";

export default function MatchStatsDetails({ addToast }) {
  const { slug: slug } = useParams();

  const [showInfo, setShowInfo] = useState(false);

  const [statistic, setStatistic] = useState({
    teams: null,
    main: [],
    form: [],
    referee: [],
    injured: [],
    yellow: [],
    firstHalf: [],
    secondHalf: [],
    h2h: []
  });

  // const statistic = {
  //   teams: {
  //     home: {
  //       name: "Ferencváros",
  //       logo: "https://example.com/logos/fradi.png"
  //     },
  //     away: {
  //       name: "Újpest FC",
  //       logo: "https://example.com/logos/ujpest.png"
  //     }
  //   },
  //   referee: [
  //     { label: "Játékvezető neve", home_value: "Antony Taylor", away_value: "" },
  //     { label: "Kiosztott sárga lapok", home_value: "1.5", away_value: "" }
  //   ],

  //   main: [
  //     { label: "Labdabirtoklás", home_value: "58%", away_value: "42%" },
  //     { label: "Összes lövés", home_value: 14, away_value: 9 },
  //     { label: "Kaput célzott lövés", home_value: 6, away_value: 3 }
  //   ],
  //   injured: [
  //     { label: "", home_value: "De Ligt", away_value: "Jordi Alba" },
  //     { label: "", home_value: "Sterling", away_value: "Richarlison" },
  //     { label: "", home_value: "Sterling" }
  //   ],
  //   yellow: [{ home_value: "Romero", away_value: "De Ligt" }],
  //   firstHalf: [{ label: "Kapura loves", home_value: "4.2", away_value: "5.7", unit: "" }],
  //   secondHalf: [{ label: "Kapura loves", home_value: "4.2", away_value: "5.7", unit: "" }],
  //   form: [],
  //   h2h: []
  // };


  //MÉRKŐZÉS STATISZTIKÁI
  useEffect(() => {
    // FONTOS: pontos URL
    fetch(`https://focifanatik.hu/api/get_match_statistics.php?slug=${slug}`)
      .then((response) => response.json())
      .then((data) => {
        setStatistic(data);
      })
      .catch((err) => console.error("Hiba a lekéréskor:", err));
  }, [slug]);



  //TITLE BEÁLLITÁS
  useEffect(() => {
    if (!statistic.teams) return;

    const title = `${statistic.teams.home.name} - ${statistic.teams.away.name} statisztika | Focifanatik`;

    document.title = title;

    let meta = document.querySelector("meta[name='description']");

    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }

    meta.setAttribute(
      "content",
      `${statistic.teams.home.name} - ${statistic.teams.away.name} mérkőzés részletes statisztikái, lövések, labdabirtoklás és elemzés a Focifanatik oldalán.`
    );
  }, [statistic.teams]);


  // AMÍG NINCS ADAT, NE RENDERELJ
  if (!statistic.teams) {
    return <div className="stats-page">Betöltés…</div>;
  }

  return (
    <div className="stats-page">

      <div className="container py-4">

        {statistic.teams && (
          <div className="details-header">

            {/* INFO GOMB */}
            <button
              className="header-info-btn"
              onClick={() => setShowInfo(true)}
            >
              <i className="bi bi-info-lg"></i>
            </button>

            {/* KÖZÉPSŐ PILL */}
            <div className="header-pill">

              <img
                src={`/images/teams/${statistic.teams.home.logo}`}
                alt={statistic.teams.home.name}
                className="header-logo"
              />

              <span className="header-team home">
                {statistic.teams.home.name}
              </span>

              <span className="header-vs">VS</span>

              <span className="header-team away">
                {statistic.teams.away.name}
              </span>

              <img
                src={`/images/teams/${statistic.teams.away.logo}`}
                alt={statistic.teams.away.name}
                className="header-logo"
              />

            </div>
          </div>
        )}

        {/* InfoModal */}
        {showInfo && <MatchStatsDetailsInfo onClose={() => setShowInfo(false)} />}

        <div>

          {/* <MatchStatsWideCard stats={statistic} />
          <MatchStatsSecondHalfCard stats={statistic} />
          <MatchStatsFirstHalfCard stats={statistic} />
          <MatchStatsYellowCard stats={statistic} />
          <MatchStatsRefereeCard stats={statistic} />
          <InjuredPlayersCard stats={statistic} /> */}


          {statistic.referee.length > 0 && <MatchStatsRefereeCard stats={statistic} />}
          {statistic.main.length > 0 && <MatchStatsWideCard stats={statistic} />}
          {statistic.firstHalf.length > 0 && <MatchStatsFirstHalfCard stats={statistic} />}
          {statistic.secondHalf.length > 0 && <MatchStatsSecondHalfCard stats={statistic} />}
          {statistic.injured.length > 0 && <InjuredPlayersCard stats={statistic} />}
          {statistic.yellow.length > 0 && <MatchStatsYellowCard stats={statistic} />}

          {statistic.form.length > 0 && <MatchStatsFormCard stats={statistic} />}
          {statistic.h2h.length > 0 && <MatchStatsH2HCard stats={statistic} />}

        </div>


      </div>
    </div >
  );

}
